import { normalizeProduct } from '@/features/shared/utils/normalizeProduct'
import {
  type UniversalProduct,
  type UniversalProductResponse,
} from '@/features/shop/services/UniversalProduct/types'

export const normalizeUniversalProductResponse = (
  data: UniversalProductResponse,
): UniversalProduct => {
  const { products = [] } = data
  let { locations = [] } = data

  // Below is the logic to filter out alcohol products from the stores that are not supposed to sell alcohol
  products[0]?.categories?.map((cat) => {
    if (cat.id === 16598) {
      locations = locations.filter((location) => location.allows_marketplace_alcohol)
    }
  })
  const normalizedProducts = products.map((product) => normalizeProduct(product))

  // If there's more than one product, sort the products by price (lowest to highest)
  // Then sort the locations to align with the products order based on store_id
  if (normalizedProducts.length > 1) {
    normalizedProducts.sort((a, b) => {
      const aPrice = a.salePrice || a.price
      const bPrice = b.salePrice || b.price
      return aPrice - bPrice
    })
    const productSortOrder = normalizedProducts.map((p) => p.storeId)
    locations.sort((a, b) => {
      return productSortOrder.indexOf(a.store_id) - productSortOrder.indexOf(b.store_id)
    })
  }

  return {
    ...data,
    products: normalizedProducts,
    locations,
  }
}
